import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const SetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password,  setPassword]  = useState('');
  const [confirm,   setConfirm]   = useState('');
  const [loading,   setLoading]   = useState(false);
  const [error,     setError]     = useState(null);
  const [success,   setSuccess]   = useState(false);

  useEffect(() => {
    if (!token) setError('Invalid link. Please ask your admin to resend the invitation.');
  }, [token]);

  const handleSubmit = async () => {
    setError(null);
    if (!password || !confirm) return setError('Please fill in both fields.');
    if (password.length < 8)   return setError('Password must be at least 8 characters.');
    if (password !== confirm)   return setError('Passwords do not match.');

    setLoading(true);
    try {
      await axios.post(`${API_URL}/auth/set-password`, { token, password });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#f4f6f9',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    }}>
      <div style={{
        background: 'white', borderRadius: 16, padding: '48px 40px',
        width: '100%', maxWidth: 440,
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 56, height: 56, borderRadius: 14,
            background: '#1e3a5f', marginBottom: 16,
          }}>
            <span style={{ fontSize: 26 }}>🛡️</span>
          </div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a' }}>
            Set up your account
          </h1>
          <p style={{ margin: '8px 0 0', fontSize: 14, color: '#6b7280' }}>
            Choose a password to activate your RegShield account.
          </p>
        </div>

        {success ? (
          <div style={{
            background: '#f0fdf4', border: '1px solid #bbf7d0',
            borderRadius: 10, padding: '20px 24px', textAlign: 'center',
          }}>
            <p style={{ fontSize: 28, margin: '0 0 8px' }}>✅</p>
            <p style={{ fontSize: 15, fontWeight: 700, color: '#16a34a', margin: '0 0 4px' }}>
              Password set successfully!
            </p>
            <p style={{ fontSize: 13, color: '#6b7280', margin: 0 }}>
              Redirecting you to login…
            </p>
          </div>
        ) : (
          <>
            {error && (
              <div style={{
                background: '#fef2f2', border: '1px solid #fecaca',
                borderRadius: 8, padding: '12px 16px',
                marginBottom: 20, fontSize: 13, color: '#dc2626', fontWeight: 600,
              }}>
                ✗ {error}
              </div>
            )}

            <div style={{ marginBottom: 18 }}>
              <label style={{
                display: 'block', fontSize: 12, fontWeight: 600,
                color: '#374151', marginBottom: 6,
                textTransform: 'uppercase', letterSpacing: '0.04em',
              }}>
                New Password <span style={{ color: '#dc2626' }}>*</span>
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="At least 8 characters"
                style={{
                  width: '100%', padding: '11px 14px', borderRadius: 8,
                  border: '1px solid #e5e7eb', fontSize: 14, color: '#111827',
                  boxSizing: 'border-box', outline: 'none',
                }}
              />
            </div>

            <div style={{ marginBottom: 28 }}>
              <label style={{
                display: 'block', fontSize: 12, fontWeight: 600,
                color: '#374151', marginBottom: 6,
                textTransform: 'uppercase', letterSpacing: '0.04em',
              }}>
                Confirm Password <span style={{ color: '#dc2626' }}>*</span>
              </label>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="Repeat your password"
                onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                style={{
                  width: '100%', padding: '11px 14px', borderRadius: 8,
                  border: '1px solid #e5e7eb', fontSize: 14, color: '#111827',
                  boxSizing: 'border-box', outline: 'none',
                }}
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={loading}
              style={{
                width: '100%', padding: '13px',
                background: loading ? '#93c5fd' : '#1e3a5f',
                color: 'white', border: 'none', borderRadius: 8,
                fontWeight: 700, fontSize: 14,
                cursor: loading ? 'not-allowed' : 'pointer',
              }}
            >
              {loading ? '⏳ Activating account…' : 'Activate my account'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SetPassword;